import { ReactNode, useEffect } from "react";
import useUrlParams from "../hooks/useUrlParams";
import { SatelliteDetails } from "../types";
import SimulateService from "../../../service/SimulateService";
import useLoader from "../hooks/useLoader";
import { showToastMessage } from "../../../utils/commonFunctions";
import useScenario from "../hooks/useScenario";
import useSatellite from "../hooks/useSatellite";

interface ScenarioProviderProps {
    children: ReactNode;
}

const ScenarioProvider = ({ children }: ScenarioProviderProps) => {
    const { setLoading } = useLoader();
    const { mission_id, scenario_id, sat_grp_id, sat_id } = useUrlParams()
    const { set_scenario, deploymentSessionType, setDeploymentSessionType, grpGrafanaData, set_grafana, setGrpGrafanaData, set_satellites } = useScenario();
    const { selected_satellite, set_satellite_groups, set_selected_satellite_group, set_selected_satellite } = useSatellite()

    const getSessionTypeFromDeploymentDetails = (raw: unknown): string | null => {
        if (!raw || typeof raw !== 'object') return null;
        const record = raw as Record<string, unknown>;
        const nestedData = record.data && typeof record.data === 'object'
            ? record.data as Record<string, unknown>
            : null;
        const value = record.sessionType ?? record.SessionType ?? nestedData?.sessionType ?? nestedData?.SessionType;
        return typeof value === 'string' && value.trim() ? value.trim() : null;
    }

    const getSatelliteInformarion = () => {
        if (!scenario_id || !mission_id || !sat_grp_id || !sat_id) {
            if (deploymentSessionType !== null) setDeploymentSessionType(null);
            return
        }
        setDeploymentSessionType(null);
        setLoading('group', true)
        SimulateService.getScenarioInfoByGroupId(scenario_id, mission_id, sat_grp_id).then((res) => {
            if (res?.data) {
                setDeploymentSessionType(getSessionTypeFromDeploymentDetails(res.data));
                const satellites = res.data?.satelliteDetails?.map((satellite: SatelliteDetails) => ({
                    label: satellite.satelliteName,
                    value: {
                        ...satellite,
                        satelliteGroupId: sat_grp_id
                    }
                }))
                const selectedSatellite = satellites.find((satellite: any) => satellite.value.satelliteId === sat_id) || satellites[0]
                set_satellites(satellites)
                set_selected_satellite(selectedSatellite)
                setLoading('telemetry', true)
                SimulateService.getGrafanaData(scenario_id, mission_id, sat_grp_id)?.then((grafanaRes) => {
                    if (grafanaRes?.data?.urls) {
                        setGrpGrafanaData(grafanaRes?.data?.urls)
                    } else {
                        setLoading('telemetry', false)
                    }
                }).catch((err) => {
                    showToastMessage('error', "Somethiing went Wrong")
                    setLoading('telemetry', false)
                })
            }
        }).catch((err) => {
            setDeploymentSessionType(null);
            showToastMessage('error', "Something went wrong")
        }).finally(() => {
            setLoading('group', false)
        })
    }

    useEffect(() => {
        if (scenario_id && sat_grp_id) {
            setLoading('scenario', true)
            SimulateService.getScenario(mission_id, scenario_id).then((res) => {
                if (res?.data) {
                    const satelliteGroups = res?.data?.satelliteGroups?.map((satelliteGroup: any) => ({
                        label: satelliteGroup?.satelliteGroupName,
                        value: satelliteGroup
                    }))
                    const selectedSatelliteGroup = satelliteGroups.find(group => group.value?.satelliteGroupId === sat_grp_id)
                    set_scenario(res.data) // need TT id for this scenario for websockete connection
                    set_satellite_groups(satelliteGroups)
                    set_selected_satellite_group(selectedSatelliteGroup)
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                setLoading('scenario', false)
            })
        }
    }, [scenario_id])

    useEffect(() => {
        if (grpGrafanaData) {
            const filteredSatellites = grpGrafanaData?.filter(
                (sat) => sat?.['SatelliteId'] === selected_satellite?.value?.satelliteId
            );
            set_grafana(filteredSatellites)
            setLoading('telemetry', false)
        }

    }, [selected_satellite, grpGrafanaData])




    useEffect(() => {
        getSatelliteInformarion()
    }, [sat_grp_id])

    return children
}

export default ScenarioProvider
